<template>
    <div class="row clearfix">
        <div v-if="loading" class="loading"></div>
        <div v-if="messageStatus" class="alert alert-success" role="alert">
            {{ messageStatus }}
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="">
                <div class="header">
                    <h2>Рассылка</h2>
                    <b-button variant="info" class="waves-effect mt-2 mb-4" @click="sendMessage()" :disabled="!valid">Отправить сообщение</b-button>
                    <!-- <router-link tag="a" :to="'/admin/mailing/edit'" class="btn btn-info waves-effect "
                                 style="margin: 15px 0">Отправить сообщение
                    </router-link> -->
                </div>
                <div class="body table-responsive">
                    <table class="table table-bordered table-striped js-table dataTable order-table">
                        <thead>
                        <tr>
                            <th>ID</th>
                            <th>E-mail</th>
                            <th>Роль</th>
                            <th>Опции  
                                <b-form-checkbox
                                    id="selectAllMsg"
                                    class="select-all-checkbox"
                                    v-model="selectAllMsg"
                                    name="selectAllMsg"
                                    value="true"
                                    unchecked-value="false"
                                    @change="addAllToMail()"
                                    >
                                    Выбрать всех
                                </b-form-checkbox>
                                <b-form-checkbox
                                    id="selectAllWhole"
                                    class="select-all-checkbox"
                                    v-model="selectAllWhole"
                                    name="selectAllWhole"
                                    value="true"
                                    unchecked-value="false"
                                    @change="addWholeToMail()"
                                    >
                                    Выбрать всех оптовиков
                                </b-form-checkbox>
                                <b-form-checkbox
                                    id="selectAllDealers"
                                    class="select-all-checkbox"
                                    v-model="selectAllDealers"
                                    name="selectAllDealers"
                                    value="true"
                                    unchecked-value="false"
                                    @change="addDealresToMail()"
                                    >
                                    Выбрать всех дилеров
                                </b-form-checkbox>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in items">
                            <td>{{ item.id }}</td>
                            <td>{{ item.email }}</td>
                            <td>{{ item.role }}</td>
                            <td>
                                <b-form-checkbox
                                    :id="item.email"
                                    v-model="selectMsg[index].value"
                                    name="selectMsg"
                                    value="true"
                                    unchecked-value="false"
                                    @change="addToMail(item.email, selectMsg[index].value)"
                                    >
                                    Выбрать 
                                </b-form-checkbox>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AdminMailings",
        // props: ['message'],
        data() {
            return {
                items: [],
                messageStatus: null,
                selectMsg: [],
                loading: false,
                valid: false,
                mailsArr: [],
                selectAllMsg: false,
                selectAllWhole: false,
                selectAllDealers: false,
            }
        },

        mounted() {
            this.messageStatus = this.$route.params.message
            this.loading = true

            this.axios
                .get(this.axios.defaults.baseURL + 'admin/subscribes')
                .then(response => {
                    this.items = response.data.subscribes;
                    console.log(this.items)
                    this.items.forEach(element => {
                        this.selectMsg.push({
                            'email': element.email,
                            'value': false,
                            'role': element.role
                        })
                    })
                })
                .catch(error => {
                    console.log(error);
                }).finally(() => {
                    this.loading = false
            })
        },

        methods: {
            addToMail(em, state) {
                if(state && !this.mailsArr.includes(em)) {
                    this.mailsArr.push(em);
                } else {
                    const index = this.mailsArr.indexOf(em);
                    this.mailsArr.splice(index, 1)
                }

                if (this.mailsArr.length > 0) {
                    this.valid = true;
                } else {
                    this.valid = false;
                }
            },

            addAllToMail() {
                this.mailsArr = []

                this.selectAllWhole = false;
                this.selectAllDealers = false;

                this.selectMsg.forEach(element => {
                    element.value = false;
                })

                if(this.selectAllMsg == 'true') {
                    this.selectMsg.forEach(element => {
                        element.value = true;
                    })

                    this.items.forEach(element => {
                        this.mailsArr.push(element.email)
                    })
                }

                if (this.mailsArr.length > 0) {
                    this.valid = true;
                } else {
                    this.valid = false;
                }
            },

            addWholeToMail() {
                this.mailsArr = []

                this.selectAllMsg = false;
                this.selectAllDealers = false;

                this.selectMsg.forEach(element => {
                    element.value = false;
                })

                if(this.selectAllWhole == 'true') {
                    this.selectMsg.forEach(element => {
                        if(element.role == 'Оптовик') {
                            element.value = true;
                        }
                    })

                    this.items.forEach(element => {
                        if(element.role == 'Оптовик') {
                            this.mailsArr.push(element.email)
                        }
                    })
                }

                if (this.mailsArr.length > 0) {
                    this.valid = true;
                } else {
                    this.valid = false;
                }
            },

            addDealresToMail() {
                this.mailsArr = []

                this.selectAllMsg = false;
                this.selectAllWhole = false;

                this.selectMsg.forEach(element => {
                    element.value = false;
                })

                if(this.selectAllDealers == 'true') {
                    this.selectMsg.forEach(element => {
                        if(element.role == 'Диллер') {
                            element.value = true;
                        }
                    })

                    this.items.forEach(element => {
                        if(element.role == 'Диллер') {
                            this.mailsArr.push(element.email)
                        }
                    })
                }

                if (this.mailsArr.length > 0) {
                    this.valid = true;
                } else {
                    this.valid = false;
                }
            },

            sendMessage() {
                this.$router.push({
                    path: 'mailings/message',
                    query: this.mailsArr
                })
            }
        }
    }
</script>

<style scoped>
        .select-all-checkbox {
            display: inline-block;
            margin-left: 10px;
        }
</style>



// WEBPACK FOOTER //
// src/views/app/admin/mailings/index.vue